import { useState } from 'react';
import '@/App.css';
import CurrencyCalculator from '@/components/CurrencyCalculator';
import MathCalculatorModal from '@/components/MathCalculatorModal';
import ForexConverterModal from '@/components/ForexConverterModal';
import HelpModal from '@/components/HelpModal';
import ContactModal from '@/components/ContactModal';
import SuggestionsModal from '@/components/SuggestionsModal';
import { Calculator, ArrowLeftRight, HelpCircle, Mail, Lightbulb } from 'lucide-react';

function App() {
  const [mathModalOpen, setMathModalOpen] = useState(false);
  const [forexModalOpen, setForexModalOpen] = useState(false);
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [suggestionsModalOpen, setSuggestionsModalOpen] = useState(false);
  const [exampleData, setExampleData] = useState(null);
  const [paymentSuggestions, setPaymentSuggestions] = useState([]);

  const openMathModal = () => {
    setForexModalOpen(false);
    setHelpModalOpen(false);
    setContactModalOpen(false);
    setMathModalOpen(true);
  };

  const openForexModal = () => {
    setMathModalOpen(false);
    setHelpModalOpen(false);
    setContactModalOpen(false);
    setForexModalOpen(true);
  };

  const openHelpModal = () => {
    setMathModalOpen(false);
    setForexModalOpen(false);
    setContactModalOpen(false);
    setHelpModalOpen(true);
  };

  const openContactModal = () => {
    setMathModalOpen(false);
    setForexModalOpen(false);
    setHelpModalOpen(false);
    setSuggestionsModalOpen(false);
    setContactModalOpen(true);
  };

  const openSuggestionsModal = () => {
    setMathModalOpen(false);
    setForexModalOpen(false);
    setHelpModalOpen(false);
    setContactModalOpen(false);
    setSuggestionsModalOpen(true);
  };

  const handleApplyExample = () => {
    setExampleData({
      price: '250000',
      priceCurrency: 'old',
      payment1: '2400',
      payment1Currency: 'new',
      payment2: '15000',
      payment2Currency: 'old',
      showPayment2: true
    });
    // Clear after applying to allow re-application
    setTimeout(() => {
      setExampleData(null);
    }, 100);
  };

  const handleSuggestionsChange = (suggestions) => {
    setPaymentSuggestions(suggestions);
  };

  const handleSelectSuggestion = (suggestion) => {
    // Use the global handler from CurrencyCalculator
    if (window.__currencyCalcHandleSuggestion) {
      window.__currencyCalcHandleSuggestion(suggestion);
    }
  };

  return (
    <div className="app-container">
      {/* Header */}
      <header className="app-header">
        <button 
          className="icon-button"
          onClick={openForexModal}
          aria-label="محول العملات"
          title="محول العملات"
        >
          <ArrowLeftRight size={24} />
        </button>
        
        <div className="header-content">
          <h1 className="app-title">حاسبة العملة السورية</h1>
          <img 
            src="/syria-eagle.svg" 
            alt="شعار سوريا" 
            className="syria-logo"
          />
        </div>
        
        <button 
          className="icon-button"
          onClick={openMathModal}
          aria-label="آلة حاسبة"
          title="آلة حاسبة"
        >
          <Calculator size={24} />
        </button>
      </header>

      {/* Main Calculator */}
      <main className="main-content">
        <CurrencyCalculator 
          exampleData={exampleData} 
          onSuggestionsChange={handleSuggestionsChange}
        />
      </main>

      {/* Floating Suggestions Button - Green, Fixed Position */}
      <button 
        className="suggestions-icon-button"
        onClick={openSuggestionsModal}
        aria-label="اقتراحات للدفع المختلط"
        title="اقتراحات للدفع المختلط"
      >
        <Lightbulb size={22} />
      </button>

      {/* Footer with Help/Contact Buttons - Scrolls with page */}
      <footer className="app-footer">
        <button 
          className="icon-button footer-icon-button"
          onClick={openContactModal}
          aria-label="تواصل معنا"
          title="تواصل معنا"
        >
          <Mail size={24} />
        </button>

        <p className="footer-text">جميع الحقوق محفوظة © 2026 MK</p>

        <button 
          className="icon-button footer-icon-button"
          onClick={openHelpModal}
          aria-label="كيفية الاستخدام"
          title="كيفية الاستخدام"
        >
          <HelpCircle size={24} />
        </button>
      </footer>

      {/* Modals */}
      <MathCalculatorModal 
        isOpen={mathModalOpen} 
        onClose={() => setMathModalOpen(false)} 
      />
      <ForexConverterModal 
        isOpen={forexModalOpen} 
        onClose={() => setForexModalOpen(false)} 
      />
      <HelpModal 
        isOpen={helpModalOpen} 
        onClose={() => setHelpModalOpen(false)}
        onApplyExample={handleApplyExample}
      />
      <ContactModal 
        isOpen={contactModalOpen} 
        onClose={() => setContactModalOpen(false)} 
      />
      <SuggestionsModal 
        isOpen={suggestionsModalOpen} 
        onClose={() => setSuggestionsModalOpen(false)}
        suggestions={paymentSuggestions}
        onSelectSuggestion={handleSelectSuggestion}
      />
    </div>
  );
}

export default App;
